import React from 'react'
import { useInternationalization } from '../../../features/i18n'
import { FormPassword } from './form-password'

const label = {
  en: 'Your Password',
  id: 'Kata Sandi Anda'
}

const ContentPassword = () => {
  const { language } = useInternationalization()

  return (
    <div className="w-full">
      <p className="text-lg font-bold mb-5 lg:mb-8">
        {label[language.name]}
      </p>
      <div style={{maxWidth: '541px'}}>
        <FormPassword />
      </div>
    </div>
  )
}

export { ContentPassword }
